export type QueryParams = "accountNumber" | "serviceType";

/**
 * Get the given query param from the URL.
 */
export const getUrlQueryParam = (param: QueryParams): string | undefined => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) ?? undefined;
};

/**
 * Adds or updates the given query param in the URL.
 * If no value is given then the param is removed from the URL.
 */
export const setUrlQueryParam = (key: QueryParams, value?: string) => {
  if (typeof window === "undefined") {
    return;
  }
  const url = new URL(window.location.href);
  if (value) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.delete(key);
  }
  window.history.replaceState({}, "", url.toString());
};

/**
 * Sets the accountNumber and removes the serviceType from the URL.
 * If no accountNumber is given then accountNumber is removed from the URL.
 */
export const setAccountNumberQueryParam = (accountNumber?: string) => {
  if (typeof window === "undefined") {
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.delete("serviceType");
  if (accountNumber) {
    url.searchParams.set("accountNumber", accountNumber);
  } else {
    url.searchParams.delete("accountNumber");
  }
  window.history.replaceState({}, "", url.toString());
};
